export const MenuIdNotifications = 'NOTIFICATIONS' as const;
